import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'card-dados-autodeclaratorio-component',
    templateUrl: 'card-dados-autodeclaratorio-component.html',
    styleUrls: ['./card-dados-autodeclaratorio-component.scss']
})

export class CardDadosAutodeclaratorioComponent implements OnInit {

    @Input() profissionalInfo: any = {};
    @Input() infoUser: any = {};

    constructor() {

    }

    ngOnInit() {
        console.log(this.infoUser);
    }
}
